import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WindowRefService } from 'i2g-ng-utils';

@Injectable()
export class ImageBuilder {
  private _urlCreator: any;

  constructor(
    private windowRefService: WindowRefService,
    private _domSanitizer: DomSanitizer
  ) {
    this._urlCreator =
      windowRefService.nativeWindow.URL ||
      windowRefService.nativeWindow.webkitURL;
  }

  buildImageUrl(blob: Blob) {
    return this._urlCreator.createObjectURL(blob);
  }

  buildSafeImageUrl(blob: Blob): SafeResourceUrl {
    return this._domSanitizer.bypassSecurityTrustResourceUrl(
      this.buildImageUrl(blob)
    );
  }
}
